
import IconAsap from '~/components/icon/IconAsap.vue';
import IconCalendarAlt from '~/components/icon/IconCalendarAlt.vue';
import IconCalendarSpecific from '~/components/icon/IconCalendarSpecific.vue';
import IconCalendarWeekend from '~/components/icon/IconCalendarWeekend.vue';
import IconDaytime from '~/components/icon/IconDaytime.vue';
import IconEvening from '~/components/icon/IconEvening.vue';

export default {
    name: 'WasteRemovalTimeForm',
    props: {
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [
                { key: 'asap', value: this.$t('datepicker.asap'), icon: IconAsap },
                { key: 'daytime', value: this.$t('datepicker.daytime'), icon: IconDaytime },
                { key: 'evenings', value: this.$t('datepicker.evenings'), icon: IconEvening },
                { key: 'flexible', value: this.$t('datepicker.flexible'), icon: IconCalendarAlt },
                { key: 'weekends', value: this.$t('datepicker.weekends'), icon: IconCalendarWeekend },
                { key: 'specific', value: this.$t('datepicker.specific_date'), icon: IconCalendarSpecific },
            ],
        };
    },
    computed: {
        today() {
            const date = new Date();
            return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(-2)}-${`0${date.getDate() + 1}`.slice(-2)}`;
        },
    },
    methods: {
        select(value) {
            /* eslint vue/no-mutating-props: 0 */
            // @todo fix this
            this.form.enumDate.$model = value;
            if (value !== 'specific') {
                this.$emit('submit');
            }
        },
        submit() {
            if (this.form.validateFields(['date', 'enumDate'])) {
                this.$emit('submit');
            }
        },
    },
};
